import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { SalePillComponent } from '../sale-pill/sale-pill.component';
import { IRangeSquaresImage } from './range-squares.component';
@Component({
    selector: 'page-component-range-squares-image',
    templateUrl: 'range-squares-image.html',
    styleUrls: ['range-squares-image.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, SizeClassDirective, IfSizeDirective, HrefComponent, SalePillComponent, ImageModule, ICmsClientModule]
})
export class PageComponentRangeSquaresImageComponent extends UiComponent {
    @Input()
    item: IRangeSquaresImage | undefined;
    @Input()
    componentVariant?: string;
    mouseIn: boolean = false;
    get smallPill() {
        return this.componentVariant === 'squares_row' && this.client.isS;
    }
    onMouseIn() {
        this.mouseIn = true;
        this.detectChanges();
    }
    onMouseOut() {
        this.mouseIn = false;
        this.detectChanges();
    }
}
